import React from 'react';
import PartnerPageTeaser from './Teaser';
import PartnerPageFull from './Full';

const PartnerPage = (props) => {
  const { entity, viewMode } = props;

  switch (viewMode) {
    case 'teaser':
      return <PartnerPageTeaser entity={entity} />;

    default:
      return <PartnerPageFull entity={entity} />;
  }
};

export default PartnerPage;
